module.exports = __webpack_public_path__ + "fonts/Vonnes-LightCond.fb4986e7.otf";